import { useAppDispatch, useAppSelector } from '../../useReduxToolkit';
import * as realtime from '../../../features/realtime/realtime.slice';
import { RealtimeMessageType } from '../../../features/realtime/realtime.types';
import {
  type ScreenshareEventData,
  ScreenshareRequestPayload,
} from '../screenshareState.types';
import { getCurrentRequestedMember } from '../../../features/screenshare/screenshare.selectors';
import { track, TrackedEvents } from '../../../features/tracking/track';

export const useRejectScreenshareRequest = (): ((
  eventData?: ScreenshareEventData,
) => Promise<void>) => {
  const dispatch = useAppDispatch();
  const currentRequestedMemberId = useAppSelector(getCurrentRequestedMember);

  const rejectScreenshareRequest = async (
    eventData?: ScreenshareEventData,
  ): Promise<void> => {
    if (currentRequestedMemberId === undefined) {
      throw new Error(
        'Screenshare rejected but currentRequestedMemberId is undefined',
      );
    }
    await dispatch(
      realtime.sendMessage({
        id: currentRequestedMemberId,
        message: {
          messageType: RealtimeMessageType.ScreenshareRequest,
          payload: {
            eventName: ScreenshareRequestPayload.Reject,
            eventData,
          },
        },
      }),
    );

    void track(TrackedEvents.ButtonClicked, {
      // eslint-disable-next-line @typescript-eslint/naming-convention,camelcase
      button_action: 'Screenshare Rejected',
    });
  };

  return rejectScreenshareRequest;
};
